import React from "react";
import styles from "./PlaceholderChips.module.scss";

export interface Placeholder {
  /** Kullanıcıya gösterilen Türkçe etiket */
  label: string;
  /** Metne eklenecek backend token'ı (ör. `{YEAR}`) */
  token: string;
  /** Açıklama tooltip'i */
  hint?: string;
}

interface PlaceholderChipsProps {
  placeholders: Placeholder[];
  onInsert: (token: string) => void;
  title?: string;
}

const PlaceholderChips: React.FC<PlaceholderChipsProps> = ({
  placeholders,
  onInsert,
  title = "Yer tutucular",
}) => {
  return (
    <div className={styles.wrap}>
      <span className={styles.title}>{title}</span>
      <div className={styles.chips}>
        {placeholders.map((p) => (
          <button
            key={p.token}
            type="button"
            className={styles.chip}
            onClick={() => onInsert(p.token)}
            title={p.hint ?? `${p.label} → ${p.token}`}
          >
            <span>{p.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlaceholderChips;
